<div class="relative" data-ordenacao-dropdown>
  <button type="button" (click)="toggle.emit()"
    class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    title="Ordenação">
    <lucide-icon name="arrow-up-down" class="w-5 h-5"></lucide-icon>
  </button>

  <div *ngIf="aberta"
    class="absolute top-full left-0 mt-2 w-72 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg z-30 overflow-hidden">
    <div
      class="px-4 py-2.5 text-xs font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
      ordenação
    </div>
    <div class="max-h-96 overflow-y-auto">
      <button type="button" *ngFor="let opcao of opcoes" (click)="selecionar.emit(opcao)"
        class="w-full px-4 py-2.5 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex items-center gap-3 border-b border-gray-100 dark:border-gray-700 last:border-b-0"
        [ngClass]="selecionada?.id === opcao.id ? 'bg-gray-50 dark:bg-gray-700/50' : ''">
        <lucide-icon [name]="getOrdenacaoIcone(opcao.id)"
          class="w-4 h-4 text-gray-500 dark:text-gray-400 shrink-0"></lucide-icon>
        <span class="flex-1">{{ opcao.label }}</span>
        <lucide-icon *ngIf="selecionada?.id === opcao.id" name="check"
          class="w-4 h-4 text-blue-600 dark:text-blue-400 shrink-0"></lucide-icon>
      </button>
    </div>
  </div>
</div>
